module.exports = __webpack_public_path__ + "media/PAG51-02.61012cd3.mp3";